import { Capacitor } from '@capacitor/core';

/** True when running inside Android or iOS native shell */
export const isNative = () => Capacitor.isNativePlatform();

/** 'web' | 'android' | 'ios' */
export const getPlatform = () => Capacitor.getPlatform();

export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isIOS = () => Capacitor.getPlatform() === 'ios';
